import { Pipe, PipeTransform } from '@angular/core';
import { Method } from '../../models/company-config';

@Pipe({
  name: 'method',
})
export class MethodPipe implements PipeTransform {
  /**
   * 
   */
  transform(value: string, methods: Method[]) {
    return methods.find(x => x.uuid == value).type.name;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/method/method.ts